// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2-Jw4","buttons":"PendingPaymentAlert_buttons__8Yt1c"};